import moment from 'moment';

export const number = (v) => {
  if (!isNaN(v)) {
    return (Math.round(v * 100) / 100).toFixed(2);
  }
  return 0;
};

export const currency = (v, symbol = '€') => {
  if (v) {
    return `${number(v)} ${symbol}`;
  }
  return v;
};

export const nl2br = a => a.replace(/(\r\n|\n\r|\r|\n)/g, '<br>');

export const formatDate = a => moment(a).format('DD/MM/YYYY');

export default {
  number,
  currency,
  nl2br,
  formatDate,
};



// WEBPACK FOOTER //
// ./src/utils/filters.js